require('../../modules/es.array.flat');
require('../../modules/es.array.unscopables.flat');

module.exports = require('../../internals/entry-unbind')('Array', 'flat');
